import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, GiftIcon, CheckCircle2Icon, DownloadIcon, CreditCardIcon, ChevronDownIcon, ShoppingCartIcon, BookOpenIcon, CalculatorIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { UpsellPopup } from './UpsellPopup';
export function PriceBlock() {
  const [showDetails, setShowDetails] = useState(false);
  const [orderBump1Checked, setOrderBump1Checked] = useState(false);
  const [orderBump2Checked, setOrderBump2Checked] = useState(false);
  const [showUpsellPopup, setShowUpsellPopup] = useState(false);
  const basePrice = 8999;
  const bump1Price = 6000;
  const bump2Price = 6000;
  const total = basePrice + (orderBump1Checked ? bump1Price : 0) + (orderBump2Checked ? bump2Price : 0);
  const formatPrice = (n: number) => `${n.toLocaleString('es-AR')}`;
  const getCheckoutUrl = (bump1: boolean, bump2: boolean) => {
    if (bump1 && bump2) return 'https://amigospeludosarg.shop/cart/49011062767858:1';
    if (bump1) return 'https://amigospeludosarg.shop/cart/49010966954226:1';
    if (bump2) return 'https://amigospeludosarg.shop/cart/49011080462578:1';
    return 'https://amigospeludosarg.shop/cart/48933114577138:1';
  };
  const handleCheckoutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!orderBump1Checked && !orderBump2Checked) {
      setShowUpsellPopup(true);
    } else {
      trackAddToCart();
      window.open(getCheckoutUrl(orderBump1Checked, orderBump2Checked), '_blank', 'noopener,noreferrer');
    }
  };
  return <section id="precio" className="w-full bg-[#2D8C5A] py-12 md:py-24 px-6" data-id="element-168">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl mx-auto text-center" data-id="element-169">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-170">
          Recuperá la paz de tu hogar hoy mismo
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed" data-id="element-171">
          Por menos de lo que cuesta un kilo de piedras premium, llevate el
          sistema completo que salvará tu sofá y tu relación con tu gato.
        </p>

        <div className="bg-white rounded-2xl p-8 md:p-10 mb-8" data-id="element-172">
          <div className="mb-6" data-id="element-173">
            <motion.div key={total} initial={{
            scale: 1.1
          }} animate={{
            scale: 1
          }} transition={{
            duration: 0.3
          }} className="text-5xl md:text-6xl font-['Playfair_Display'] font-bold text-[#1C1C1C] mb-2" data-id="element-174">
              ${formatPrice(total)}
            </motion.div>
            <div className="text-lg text-[#1C1C1C]/70" data-id="element-175">
              Pago único - Descarga inmediata
            </div>
          </div>

          <div className="text-left bg-[#FAFAF7] rounded-lg p-3.5 md:p-6 mb-5 border border-[#1C1C1C]/5" data-id="element-176">
            <p className="text-xs font-semibold text-[#1C1C1C]/60 uppercase tracking-wide mb-2.5" data-id="element-177">
              Tu pack incluye:
            </p>
            <div className="space-y-2" data-id="element-178">
              <div className="flex items-center gap-2" data-id="element-179">
                <CheckCircle2Icon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-180" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-181">
                  <strong data-id="element-182">eBook:</strong> Protocolo de 72 Horas
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-183">
                <GiftIcon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-184" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-185">
                  <strong data-id="element-186">Bono 1:</strong> Auditoría + Mapa N+1
                  <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-187">
                    GRATIS
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-188">
                <GiftIcon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-189" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-190">
                  <strong data-id="element-191">Bono 2:</strong> Kit "Sin Culpa" + Scripts
                  <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-192">
                    GRATIS
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-193">
                <GiftIcon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-194" />
                <span className="text-[#1C1C1C] text-sm" data-id="element-195">
                  <strong data-id="element-196">Bono 3:</strong> Checklist "Bandeja Perfecta"
                  <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-197">
                    GRATIS
                  </span>
                </span>
              </div>
              <AnimatePresence data-id="element-198">
                {orderBump1Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-199">
                    <div className="flex items-center gap-2 pt-1" data-id="element-200">
                      <CheckCircle2Icon className="w-4 h-4 text-[#D97706] flex-shrink-0" data-id="element-201" />
                      <span className="text-[#1C1C1C] text-sm" data-id="element-202">
                        <strong data-id="element-203">Extra:</strong> Scanner de Limpieza
                        <span className="ml-1.5 inline-block bg-[#D97706]/10 text-[#D97706] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-204">
                          +$6.000
                        </span>
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>
              <AnimatePresence data-id="element-205">
                {orderBump2Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-206">
                    <div className="flex items-center gap-2 pt-1" data-id="element-207">
                      <CheckCircle2Icon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0" data-id="element-208" />
                      <span className="text-[#1C1C1C] text-sm" data-id="element-209">
                        <strong data-id="element-210">Extra:</strong> Calendario 72 Horas
                        <span className="ml-1.5 inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-211">
                          +$6.000
                        </span>
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <AnimatePresence data-id="element-212">
              {showDetails && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-213">
                  <div className="mt-4 pt-4 border-t border-[#1C1C1C]/10 space-y-5" data-id="element-214">
                    <div data-id="element-215">
                      <p className="text-xs font-bold text-[#2D8C5A] uppercase tracking-wide mb-1.5" data-id="element-216">
                        BONO #1
                      </p>
                      <p className="text-sm font-semibold text-[#1C1C1C] mb-1" data-id="element-217">
                        Auditoría Express "Puntos Calientes" (10 Min) + Mapa de
                        Bandejas N+1
                      </p>
                      <p className="text-xs text-[#8B4513] font-semibold mb-2" data-id="element-218">
                        Valor real:{' '}
                        <span className="line-through opacity-70" data-id="element-219">
                          $14.000 ARS
                        </span>{' '}
                        — Hoy: GRATIS
                      </p>
                      <p className="text-xs text-[#1C1C1C]/70 leading-relaxed mb-2" data-id="element-220">
                        Auditoría guiada de 10 minutos para detectar los
                        disparadores reales del marcaje en tu hogar. Checklist
                        de barrido, scorecard de riesgo (0 a 20 puntos) y mapas
                        de ubicación N+1 listos para 1, 2 o 3 gatos.
                      </p>
                      <div className="space-y-1.5" data-id="element-221">
                        {['Checklist "Barrido del Hogar en 10 Min"', 'Scorecard de riesgo de ubicación', 'Mapas N+1 para 1, 2 y 3 gatos', 'Plantilla "Mis 2 ubicaciones candidatas"', 'Tracker de 7 días del patrón de marcaje'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-222">
                            <CheckCircle2Icon className="w-3 h-3 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-223" />
                            <span className="text-[#1C1C1C]/80 text-xs" data-id="element-224">
                              {item}
                            </span>
                          </div>)}
                      </div>
                      <p className="text-xs text-[#2D8C5A] font-medium mt-2" data-id="element-225">
                        ✓ En 10 min sabés qué cambiar. En 48 hs ya lo cambiaste.
                      </p>
                    </div>

                    <div data-id="element-226">
                      <p className="text-xs font-bold text-[#2D8C5A] uppercase tracking-wide mb-1.5" data-id="element-227">
                        BONO #2
                      </p>
                      <p className="text-sm font-semibold text-[#1C1C1C] mb-1" data-id="element-228">
                        Kit de Comunicación "Sin Culpa" (Scripts + Carteles +
                        Plan de 3 Días)
                      </p>
                      <p className="text-xs text-[#8B4513] font-semibold mb-2" data-id="element-229">
                        Valor real:{' '}
                        <span className="line-through opacity-70" data-id="element-230">
                          $12.700 ARS
                        </span>{' '}
                        — Hoy: GRATIS
                      </p>
                      <p className="text-xs text-[#1C1C1C]/70 leading-relaxed mb-2" data-id="element-231">
                        Las palabras exactas para que tu pareja, hijos, visitas
                        y roommate entiendan las reglas sin discusiones ni
                        dramas.
                      </p>
                      <div className="space-y-1.5" data-id="element-232">
                        {['12 scripts listos para pareja, hijos, visitas y roommates', 'Protocolo Silencioso 90s para accidentes', '6 carteles imprimibles para zonas clave', 'Plan de 3 días (rutina mañana/tarde/noche)', 'Auto-guión anti-culpa para resetear tu cabeza'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-233">
                            <CheckCircle2Icon className="w-3 h-3 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-234" />
                            <span className="text-[#1C1C1C]/80 text-xs" data-id="element-235">
                              {item}
                            </span>
                          </div>)}
                      </div>
                      <p className="text-xs text-[#2D8C5A] font-medium mt-2" data-id="element-236">
                        ✓ Casa alineada desde el Día 1. Sin sabotajes.
                      </p>
                    </div>

                    <div data-id="element-237">
                      <p className="text-xs font-bold text-[#2D8C5A] uppercase tracking-wide mb-1.5" data-id="element-238">
                        BONO #3
                      </p>
                      <p className="text-sm font-semibold text-[#1C1C1C] mb-1" data-id="element-239">
                        Checklist "Bandeja Perfecta" (2 Min al Día)
                      </p>
                      <p className="text-xs text-[#8B4513] font-semibold mb-2" data-id="element-240">
                        Valor real:{' '}
                        <span className="line-through opacity-70" data-id="element-241">
                          $9.500 ARS
                        </span>{' '}
                        — Hoy: GRATIS
                      </p>
                      <p className="text-xs text-[#1C1C1C]/70 leading-relaxed mb-2" data-id="element-242">
                        2 minutos al día. Una checklist AM/PM para mantener la
                        bandeja en el estándar exacto que hace que tu gato la
                        elija por instinto, todos los días.
                      </p>
                      <div className="space-y-1.5" data-id="element-243">
                        {['Checklist AM/PM imprimible (1 página A4)', 'Rutina de reset semanal anti-recaídas', 'Tracker de 14 días con AM/PM + eventos', 'Mini guía "3 ajustes express"', 'Versión móvil optimizada'].map((item, i) => <div key={i} className="flex items-start gap-1.5" data-id="element-244">
                            <CheckCircle2Icon className="w-3 h-3 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-245" />
                            <span className="text-[#1C1C1C]/80 text-xs" data-id="element-246">
                              {item}
                            </span>
                          </div>)}
                      </div>
                      <p className="text-xs text-[#2D8C5A] font-medium mt-2" data-id="element-247">
                        ✓ En 14 días el hábito de caja se consolida.
                      </p>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <button onClick={() => setShowDetails(!showDetails)} className="mt-3 flex items-center gap-1.5 text-[#2D8C5A] text-xs font-semibold hover:text-[#1f6b42] transition-colors cursor-pointer" data-id="element-248">
              <span data-id="element-249">
                {showDetails ? 'Ver menos' : 'Leer más sobre los bonos'}
              </span>
              <motion.div animate={{
              rotate: showDetails ? 180 : 0
            }} transition={{
              duration: 0.25
            }} data-id="element-250">
                <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-251" />
              </motion.div>
            </button>

            <div className="mt-2.5 pt-2.5 border-t border-[#1C1C1C]/10 flex justify-between items-center" data-id="element-252">
              <span className="text-xs text-[#1C1C1C]/60" data-id="element-253">
                Valor: <span className="line-through" data-id="element-254">$45.199</span>
              </span>
              <motion.span key={total} initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} transition={{
              duration: 0.3
            }} className="text-base font-bold text-[#2D8C5A]" data-id="element-255">
                Hoy: ${formatPrice(total)}
              </motion.span>
            </div>
          </div>

          <motion.button onClick={handleCheckoutClick} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-[#2A5C42] text-white font-bold px-8 py-5 rounded-lg text-lg md:text-xl hover:bg-[#1f4531] transition-colors mb-4 text-center cursor-pointer shadow-lg" data-id="element-256">
            {orderBump1Checked || orderBump2Checked ? `SÍ, QUIERO TODO EL PACK COMPLETO — ${formatPrice(total)} ARS` : `QUIERO RESOLVER ESTO HOY — ${formatPrice(basePrice)} ARS`}
          </motion.button>

          {/* ORDER BUMP #1 - Limpieza Técnica */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} onClick={() => setOrderBump1Checked(!orderBump1Checked)} className={`mb-4 rounded-xl border-2 transition-all cursor-pointer relative overflow-hidden ${orderBump1Checked ? 'border-[#D97706] bg-[#FEF3C7]' : 'border-dashed border-[#D97706] bg-white'}`} data-id="element-257">
            <div className="bg-[#D97706] text-white text-xs font-bold uppercase tracking-wider text-center py-1.5 px-4" data-id="element-258">
              ⭐ Altamente recomendado
            </div>
            <div className="p-5 md:p-6" data-id="element-259">
              <div data-id="element-260">
                <h3 className="font-['Playfair_Display'] text-lg md:text-xl font-bold text-[#1C1C1C] mb-3" data-id="element-261">
                  ⚠️ ¡ALERTA! Lavandina = cartel de "BAÑO AQUÍ" para tu gato
                </h3>
                <p className="text-sm text-[#1C1C1C]/80 leading-relaxed mb-4" data-id="element-262">
                  Si no neutralizás el olor, el gato volverá a marcar.
                </p>
                <div className="mb-4" data-id="element-263">
                  <img src="https://cdn.magicpatterns.com/uploads/f4Mk4cvL556mjqGQ7Cr1gb/ORDER_BUMP_01.png" alt="Scanner de Limpieza" className="w-full max-w-md mx-auto rounded-lg shadow-md" data-id="element-264" />
                </div>
                <p className="text-sm font-semibold text-[#1C1C1C] mb-3" data-id="element-265">
                  Sumá el Scanner de Limpieza por solo{' '}
                  <span className="text-[#D97706] text-base" data-id="element-266">$6.000</span> y
                  llevate:
                </p>
                <div className="space-y-2 mb-4" data-id="element-267">
                  {['Guía de Marcas Argentina: qué comprar y qué evitar para romper la molécula del olor.', 'Receta Casera: neutralizador enzimático con 3 ingredientes de tu cocina.', 'Protocolo de Telas: paso a paso para salvar colchones, sillones y madera.'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-268">
                      <CheckCircle2Icon className="w-4 h-4 text-[#D97706] flex-shrink-0 mt-0.5" data-id="element-269" />
                      <span className="text-xs text-[#1C1C1C]/80" data-id="element-270">{item}</span>
                    </div>)}
                </div>
                <div className="flex items-center justify-between bg-white/50 rounded-lg p-3 border border-[#D97706]/20" data-id="element-271">
                  <span className="text-sm font-medium text-[#1C1C1C]" data-id="element-272">
                    Valor:{' '}
                    <span className="line-through text-[#1C1C1C]/60" data-id="element-273">
                      $9.500
                    </span>
                  </span>
                  <span className={`font-bold px-4 py-2 rounded-lg text-sm transition-colors ${orderBump1Checked ? 'bg-[#B45309] text-white' : 'bg-[#D97706] text-white'}`} data-id="element-274">
                    {orderBump1Checked ? '✓ Agregado' : 'Sí, agregar por $6.000'}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* ORDER BUMP #2 - Control y Señales */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} onClick={() => setOrderBump2Checked(!orderBump2Checked)} className={`mb-6 rounded-xl border-2 transition-all cursor-pointer relative overflow-hidden ${orderBump2Checked ? 'border-[#2D8C5A] bg-[#E8F0E8]' : 'border-dashed border-[#2D8C5A] bg-white'}`} data-id="element-275">
            <div className="bg-[#2D8C5A] text-white text-xs font-bold uppercase tracking-wider text-center py-1.5 px-4" data-id="element-276">
              ⭐ Altamente recomendado
            </div>
            <div className="p-5 md:p-6" data-id="element-277">
              <div data-id="element-278">
                <h3 className="font-['Playfair_Display'] text-lg md:text-xl font-bold text-[#1C1C1C] mb-3" data-id="element-279">
                  ✅ ¿Y si pudieras anticipar el accidente antes de que pase?
                </h3>
                <p className="text-sm text-[#1C1C1C]/80 leading-relaxed mb-4" data-id="element-280">
                  Tu gato te avisa antes de marcar — pero si no sabés leer las
                  señales, siempre llegás tarde. Este calendario te guía hora
                  por hora y te enseña a detectar el momento exacto.
                </p>
                <div className="mb-4" data-id="element-281">
                  <img src="https://cdn.magicpatterns.com/uploads/xjbYaLUMozNrPhxSXb4rRo/order_bump_02.png" alt="Calendario 72 Horas de Victoria" className="w-full max-w-md mx-auto rounded-lg shadow-md" data-id="element-282" />
                </div>
                <p className="text-sm font-semibold text-[#1C1C1C] mb-3" data-id="element-283">
                  Agregalo por solo{' '}
                  <span className="text-[#2D8C5A] text-base" data-id="element-284">$6.000</span> y
                  obtené:
                </p>
                <div className="space-y-2 mb-4" data-id="element-285">
                  {['Semáforo Felino: fotos reales para leer si tu gato está relajado, en duda o a punto de marcar.', 'Hoja de Ruta Visual: qué esperar en la hora 12, 24, 48 y 72 para no frustrarte.', 'Log de Diagnóstico: anotá cuándo y dónde para descubrir el disparador real de tu casa.'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-286">
                      <CheckCircle2Icon className="w-4 h-4 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-287" />
                      <span className="text-xs text-[#1C1C1C]/80" data-id="element-288">{item}</span>
                    </div>)}
                </div>
                <div className="flex items-center justify-between bg-white/50 rounded-lg p-3 border border-[#2D8C5A]/20" data-id="element-289">
                  <span className="text-sm font-medium text-[#1C1C1C]" data-id="element-290">
                    Valor:{' '}
                    <span className="line-through text-[#1C1C1C]/60" data-id="element-291">
                      $9.500
                    </span>
                  </span>
                  <span className={`font-bold px-4 py-2 rounded-lg text-sm transition-colors ${orderBump2Checked ? 'bg-[#1f6b42] text-white' : 'bg-[#2D8C5A] text-white'}`} data-id="element-292">
                    {orderBump2Checked ? '✓ Agregado' : 'Sí, agregar por $6.000'}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* ── RESUMEN DINÁMICO ── */}
          <motion.div layout className="mb-6 rounded-xl bg-[#FAFAF7] border border-[#1C1C1C]/10 overflow-hidden" data-id="element-293">
            <div className="divide-y divide-[#1C1C1C]/5" data-id="element-294">
              <AnimatePresence data-id="element-295">
                {orderBump1Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-296">
                    <div className="px-5 py-3 flex items-center justify-between bg-[#FEF3C7]/50" data-id="element-297">
                      <span className="text-sm text-[#1C1C1C]" data-id="element-298">
                        ⚠️ Scanner de Limpieza Técnica
                      </span>
                      <span className="text-sm font-semibold text-[#D97706]" data-id="element-299">
                        +{formatPrice(bump1Price)}
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>

              <AnimatePresence data-id="element-300">
                {orderBump2Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-301">
                    <div className="px-5 py-3 flex items-center justify-between bg-[#E8F0E8]/50" data-id="element-302">
                      <span className="text-sm text-[#1C1C1C]" data-id="element-303">
                        ✅ Calendario 72 Horas de Victoria
                      </span>
                      <span className="text-sm font-semibold text-[#2D8C5A]" data-id="element-304">
                        +{formatPrice(bump2Price)}
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </motion.div>

          {/* ── VALUE STACK — Resumen de lo que te llevás hoy ── */}
          <div className="mb-6 rounded-2xl bg-white shadow-lg border border-[#1C1C1C]/10 overflow-hidden" data-id="element-305">
            <div className="bg-[#FAFAF7] border-b border-[#1C1C1C]/10 px-3 py-2.5 md:px-5 md:py-3 flex justify-between items-center" data-id="element-306">
              <span className="font-semibold text-[#1C1C1C] text-sm md:text-base" data-id="element-307">
                Lo que recibís hoy
              </span>
              <span className="font-semibold text-[#1C1C1C] text-sm md:text-base" data-id="element-308">
                Valor real
              </span>
            </div>
            <div className="divide-y divide-[#1C1C1C]/5" data-id="element-309">
              <div className="px-3 py-2.5 md:px-5 md:py-4 flex items-center justify-between gap-2" data-id="element-310">
                <div className="flex items-center gap-2 min-w-0" data-id="element-311">
                  <BookOpenIcon className="w-4 h-4 md:w-5 md:h-5 text-[#2D8C5A] flex-shrink-0" data-id="element-312" />
                  <span className="text-[#1C1C1C] text-sm md:text-base truncate" data-id="element-313">
                    <span className="hidden md:inline" data-id="element-314">
                      eBook Principal: El Protocolo de 72 Horas
                    </span>
                    <span className="md:hidden" data-id="element-315">eBook: Protocolo 72 Horas</span>
                  </span>
                </div>
                <span className="text-[#1C1C1C]/70 line-through text-sm md:text-base whitespace-nowrap flex-shrink-0" data-id="element-316">
                  $8.999
                </span>
              </div>
              <div className="px-3 py-2.5 md:px-5 md:py-4 flex items-center justify-between gap-2" data-id="element-317">
                <div className="flex items-center gap-2 min-w-0" data-id="element-318">
                  <GiftIcon className="w-4 h-4 md:w-5 md:h-5 text-[#2D8C5A] flex-shrink-0" data-id="element-319" />
                  <span className="text-[#1C1C1C] text-sm md:text-base" data-id="element-320">
                    <span className="hidden md:inline" data-id="element-321">
                      BONO #1: Auditoría Express "Puntos Calientes" (Diagnóstico
                      en 10 min)
                    </span>
                    <span className="md:hidden" data-id="element-322">Bono 1: Auditoría Express</span>
                  </span>
                </div>
                <span className="text-[#1C1C1C]/70 line-through text-sm md:text-base whitespace-nowrap flex-shrink-0" data-id="element-323">
                  $14.000
                </span>
              </div>
              <div className="px-3 py-2.5 md:px-5 md:py-4 flex items-center justify-between gap-2" data-id="element-324">
                <div className="flex items-center gap-2 min-w-0" data-id="element-325">
                  <GiftIcon className="w-4 h-4 md:w-5 md:h-5 text-[#2D8C5A] flex-shrink-0" data-id="element-326" />
                  <span className="text-[#1C1C1C] text-sm md:text-base" data-id="element-327">
                    <span className="hidden md:inline" data-id="element-328">
                      BONO #2: Kit de Comunicación "Sin Culpa" + Scripts +
                      Carteles
                    </span>
                    <span className="md:hidden" data-id="element-329">Bono 2: Kit "Sin Culpa"</span>
                  </span>
                </div>
                <span className="text-[#1C1C1C]/70 line-through text-sm md:text-base whitespace-nowrap flex-shrink-0" data-id="element-330">
                  $12.700
                </span>
              </div>
              <div className="px-3 py-2.5 md:px-5 md:py-4 flex items-center justify-between gap-2" data-id="element-331">
                <div className="flex items-center gap-2 min-w-0" data-id="element-332">
                  <GiftIcon className="w-4 h-4 md:w-5 md:h-5 text-[#2D8C5A] flex-shrink-0" data-id="element-333" />
                  <span className="text-[#1C1C1C] text-sm md:text-base" data-id="element-334">
                    <span className="hidden md:inline" data-id="element-335">
                      BONO #3: Checklist "Bandeja Perfecta" (2 Min al Día) +
                      Tracker 14 días
                    </span>
                    <span className="md:hidden" data-id="element-336">Bono 3: Checklist Bandeja</span>
                  </span>
                </div>
                <span className="text-[#1C1C1C]/70 line-through text-sm md:text-base whitespace-nowrap flex-shrink-0" data-id="element-337">
                  $9.500
                </span>
              </div>

              <AnimatePresence data-id="element-338">
                {orderBump1Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-339">
                    <div className="px-3 py-2.5 md:px-5 md:py-4 flex items-center justify-between gap-2 bg-[#FEF3C7]/30" data-id="element-340">
                      <div className="flex items-center gap-2 min-w-0" data-id="element-341">
                        <CheckCircle2Icon className="w-4 h-4 md:w-5 md:h-5 text-[#D97706] flex-shrink-0" data-id="element-342" />
                        <span className="text-[#1C1C1C] text-sm md:text-base" data-id="element-343">
                          <span className="hidden md:inline" data-id="element-344">
                            Scanner de Limpieza Técnica
                          </span>
                          <span className="md:hidden" data-id="element-345">Scanner Limpieza</span>
                        </span>
                      </div>
                      <span className="text-[#D97706] font-semibold text-sm md:text-base whitespace-nowrap flex-shrink-0" data-id="element-346">
                        $6.000
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>
              <AnimatePresence data-id="element-347">
                {orderBump2Checked && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-348">
                    <div className="px-3 py-2.5 md:px-5 md:py-4 flex items-center justify-between gap-2 bg-[#E8F0E8]/30" data-id="element-349">
                      <div className="flex items-center gap-2 min-w-0" data-id="element-350">
                        <CheckCircle2Icon className="w-4 h-4 md:w-5 md:h-5 text-[#2D8C5A] flex-shrink-0" data-id="element-351" />
                        <span className="text-[#1C1C1C] text-sm md:text-base" data-id="element-352">
                          <span className="hidden md:inline" data-id="element-353">
                            Calendario 72 Horas de Victoria
                          </span>
                          <span className="md:hidden" data-id="element-354">Calendario 72 Horas</span>
                        </span>
                      </div>
                      <span className="text-[#2D8C5A] font-semibold text-sm md:text-base whitespace-nowrap flex-shrink-0" data-id="element-355">
                        $6.000
                      </span>
                    </div>
                  </motion.div>}
              </AnimatePresence>

              <div className="bg-[#FAFAF7] px-3 py-2.5 md:px-5 md:py-4 flex items-center justify-between gap-2" data-id="element-356">
                <div className="flex items-center gap-2 min-w-0" data-id="element-357">
                  <CalculatorIcon className="w-4 h-4 md:w-5 md:h-5 text-[#1C1C1C] flex-shrink-0" data-id="element-358" />
                  <span className="text-[#1C1C1C] font-semibold text-sm md:text-base" data-id="element-359">
                    Valor total del pack
                  </span>
                </div>
                <span className="font-semibold text-[#1C1C1C] text-sm md:text-base whitespace-nowrap flex-shrink-0" data-id="element-360">
                  $45.199
                </span>
              </div>

              <div className="bg-[#2D8C5A]/10 px-3 py-3 md:px-5 md:py-5 flex items-center justify-between gap-2" data-id="element-361">
                <div className="flex items-center gap-2 min-w-0" data-id="element-362">
                  <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-[#2D8C5A] flex-shrink-0" data-id="element-363" />
                  <span className="text-[#2D8C5A] font-bold text-base md:text-lg" data-id="element-364">
                    Tu inversión hoy
                  </span>
                </div>
                <motion.span key={total} initial={{
                scale: 1.1
              }} animate={{
                scale: 1
              }} transition={{
                duration: 0.3
              }} className="font-bold text-xl md:text-2xl text-[#2D8C5A] whitespace-nowrap flex-shrink-0" data-id="element-365">
                  {formatPrice(total)}
                </motion.span>
              </div>

              <div className="px-3 py-4 md:px-5 md:py-5" data-id="element-366">
                <motion.button onClick={handleCheckoutClick} whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="block w-full bg-[#2A5C42] text-white font-bold px-6 py-4 rounded-lg text-base md:text-lg hover:bg-[#1f4531] transition-colors text-center cursor-pointer shadow-lg" data-id="element-367">
                  {orderBump1Checked || orderBump2Checked ? `SÍ, QUIERO TODO EL PACK COMPLETO — ${formatPrice(total)} ARS` : `QUIERO RESOLVER ESTO HOY — ${formatPrice(basePrice)} ARS`}
                </motion.button>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center gap-2 text-[#1C1C1C]/70 text-sm font-medium mb-8" data-id="element-368">
            <div className="flex items-center gap-2" data-id="element-369">
              <DownloadIcon className="w-4 h-4" data-id="element-370" />
              <span data-id="element-371">Descarga inmediata</span>
            </div>
          </div>

          <div className="bg-[#E8F0E8] border border-[#2D8C5A]/20 rounded-xl p-6 mb-6 text-left" data-id="element-372">
            <h4 className="font-['Playfair_Display'] text-lg font-bold text-[#2D8C5A] mb-2 flex items-center gap-2" data-id="element-373">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-374" />
              Garantía de "Paz Mental"
            </h4>
            <p className="text-[#1C1C1C]/80 text-sm leading-relaxed" data-id="element-375">
              Si aplicás el protocolo y en 7 días no ves un cambio en el
              comportamiento de tu gato, te devuelvo el dinero.
            </p>
          </div>

          <div className="text-center" data-id="element-376">
            <p className="text-[#8B4513] font-medium text-sm italic" data-id="element-377">
              "Esto cuesta menos que un combo de hamburguesa grande, pero salva
              tu sofá de $400.000 y tu paz mental para siempre."
            </p>
          </div>
        </div>
      </motion.div>

      <UpsellPopup isOpen={showUpsellPopup} onClose={() => setShowUpsellPopup(false)} data-id="element-378" />
    </section>;
}